module.exports = __webpack_public_path__ + "static/media/PHEV_icon.37f6d5ff.svg";